





































import { Component, Vue, Watch } from "vue-property-decorator";
import { Cutter, CutterMaterial, cuttersStore } from "@/utils/cutter";
import CutterForm from "@/components/CutterForm.vue";

@Component({ components: { CutterForm } })
export default class Cutters extends Vue {
  cutters: Record<string, Cutter> = cuttersStore.get().reduce(
    (acc, ea) => ({
      ...acc,
      [ea.name]: ea,
    }),
    {}
  );

  updateCutter(name: string): (cutter: Cutter) => void {
    return (cutter: Cutter) => {
      if (cutter.name !== name) {
        delete this.cutters[name];
      }
      this.cutters = { ...this.cutters, [cutter.name]: cutter };
    };
  }

  deleteCutter(name: string): () => void {
    return () => {
      delete this.cutters[name];
      this.cutters = { ...this.cutters };
    };
  }

  @Watch("cutters", { deep: true })
  cuttersUpdated(): void {
    cuttersStore.set(Object.values(this.cutters));
  }

  addNewCutter() {
    this.cutters = {
      ...this.cutters,
      "New Cutter": {
        name: "New Cutter",
        material: CutterMaterial.carbide,
        diameter: 0.25,
        length: 0.75,
        flutes: 3,
        shankDiameter: 0.25,
        overallStickout: 1,
      },
    };
  }
}
